import ZidPayDemo from "./ZidPayDemo"

export default ZidPayDemo
